import { useContext, useRef, useEffect } from 'react'
import { PlayerContext } from '../../pages/Home'
import { getRecordingUrl } from '../../api/api.cdlbt.co'

const AudioPlayer = () => {
  const {
    nowPlaying,
    isPlaying,
    volume,
    seekTime,
    nextRecording,
    updatePlayTime,
    onRecordingLoaded,
  } = useContext(PlayerContext)

  const ref = useRef(null)
  if (ref.current) {
    if (isPlaying) {
      ref.current.play()
    } else {
      ref.current.pause()
    }
  }

  useEffect(() => {
    ref.current.volume = volume
  }, [volume])

  useEffect(() => {
    ref.current.currentTime = seekTime
  }, [seekTime])

  return (
    <audio
      src={getRecordingUrl(nowPlaying?.name)}
      ref={ref}
      onEnded={nextRecording}
      onTimeUpdate={updatePlayTime}
      onLoadedData={onRecordingLoaded}
    />
  )
}
export default AudioPlayer
